<template>
  <div class="main-container">
    <Tabs v-model="tabVal">
      <TabPane label="人身个险" name="1"></TabPane>
      <TabPane label="团财" name="2"></TabPane>
    </Tabs>

    <insureOrder v-show="tabVal == '1'"></insureOrder>
    <groupOrder v-show="tabVal == '2'"></groupOrder>
  </div>
</template>

<script>
import insureOrder from './insureOrder';
import groupOrder from './groupOrder';
export default {
  components: {
    insureOrder,
    groupOrder
  },
  data() {
    return {
      tabVal: '1'
    };
  }
};
</script>

<style lang="scss" scoped></style>
